import React, { useState } from 'react';
import S from './HireTable.styles';
import EcommerceService from '@core/ecommerce/services/EcommerceService';
import { formatStringDate } from '@helpers/date';
import { ReactComponent as CalendarIcon } from '@img/icons/calendar.svg';
import { ReactComponent as Info } from '@img/icons/info.svg';
import { ReactComponent as TruckIcon } from '@img/icons/truck.svg';
import Heading from '@stories/Components/Global/Typography/Heading';
import Paragraph from '@stories/Components/Global/Typography/Paragraph';
import Modal from '@stories/Components/Media/Modal/Modal';
import Loader from '@stories/Components/Misc/Loader/Loader';
const HireTable = ({ labels, items, isLoading, onExtend }) => {
    const [offHireModalOpen, setOffHireModalOpen] = useState(false);
    const hasOffHireLabels = labels.offHireDisclaimerTitle !== null && labels.offHireDisclaimerCopy !== null;
    return (React.createElement(S.Wrapper, null,
        hasOffHireLabels && (React.createElement(Modal, { isActive: offHireModalOpen, onClose: () => setOffHireModalOpen(false) },
            React.createElement(Heading, { semantic: "h3", visual: "h5" }, labels.offHireDisclaimerTitle),
            React.createElement(Paragraph, { size: "small" }, labels.offHireDisclaimerCopy))),
        React.createElement(S.Table, null,
            React.createElement(S.Row, { header: true },
                React.createElement(S.Column, null, labels.extendLabel),
                React.createElement(S.Column, null, labels.onHireLabel),
                React.createElement(S.Column, null,
                    labels.offHireLabel,
                    hasOffHireLabels && (React.createElement(S.Indicator, { onClick: () => setOffHireModalOpen(true) },
                        React.createElement(Info, null)))),
                React.createElement(S.Column, null, labels.orderNoLabel),
                React.createElement(S.Column, null, labels.yourRefLabel),
                React.createElement(S.Column, null, labels.siteLabel),
                React.createElement(S.Column, { centerText: true }, labels.trackingUrlLabel),
                React.createElement(S.Column, null, labels.orderDocumentLabel)),
            isLoading ? (React.createElement(S.MinHeightPlaceholder, null,
                React.createElement(S.FixedInner, null,
                    React.createElement(Loader, null)))) : items.length > 0 ? (items.map((x) => (React.createElement(S.Row, { key: x.customerRef },
                React.createElement(S.Column, null,
                    React.createElement(S.ExtendButton, { isLive: x.onHire, onClick: () => onExtend(x) },
                        React.createElement(CalendarIcon, null))),
                React.createElement(S.Column, null, formatStringDate(x.hireDateStart)),
                React.createElement(S.Column, null, !x.onHire && x.hireDateEnd ? formatStringDate(x.hireDateEnd) : null),
                React.createElement(S.Column, null, x.orderNumber),
                React.createElement(S.Column, null, x.customerRef),
                React.createElement(S.Column, null,
                    x.siteAddress.address1 != null && x.siteAddress.address1.length > 0
                        ? `${x.siteAddress.address1}, `
                        : '',
                    x.siteAddress.address2 != null && x.siteAddress.address2.length > 0
                        ? `${x.siteAddress.address2}, `
                        : '',
                    x.siteAddress.postcode),
                React.createElement(S.Column, { centerText: true },
                    React.createElement(S.TrackingLink, { href: x.trackerUrl, target: "_blank", rel: "noreferrer" },
                        React.createElement(TruckIcon, null))),
                React.createElement(S.Column, null, !x.onHire ? (React.createElement(S.DownloadButton, { href: EcommerceService.GetDownloadPdfUrl({ orderNumber: x.orderNumber }), download: true },
                    React.createElement("img", { src: "/SiteFiles/Images/reader-icon.png", alt: "PdfSquare" }),
                    React.createElement("small", null, labels.downloadLabel))) : null))))) : (React.createElement(S.MinHeightPlaceholder, null,
                React.createElement(S.FixedInner, null,
                    React.createElement(S.NoResults, null, labels.noResultsFoundLabel)))))));
};
export default HireTable;
